import { AlertCircle, CheckCircle2, QrCode } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { useOrderCreateStore } from '@/stores/order-create'

export function OrderResult() {
  const {
    createdOrderId,
    createdPayPrice,
    paymentQrcodeStatus,
    paymentQrcode,
    paymentDepartmentName,
    reset,
  } = useOrderCreateStore()

  const hasPaymentQrcode = paymentQrcodeStatus === 'available' && paymentQrcode
  const fallbackText = paymentQrcodeStatus === 'no_department'
    ? '当前员工未分配部门，暂无收款码'
    : paymentDepartmentName
      ? `顶级部门「${paymentDepartmentName}」未设置收款码，请到结算设置配置`
      : '暂无可用收款码，请到结算设置配置'

  return (
    <div className="flex items-center justify-center py-12">
      <Card className="w-full max-w-md">
        <CardContent className="flex flex-col items-center gap-6 py-8">
          <CheckCircle2 className="h-16 w-16 text-green-500" />
          <div className="text-center space-y-2">
            <h2 className="text-xl font-bold">订单创建成功</h2>
            <p className="text-muted-foreground">
              订单号: <span className="font-mono font-medium">{createdOrderId}</span>
            </p>
            <p className="text-2xl font-bold text-red-600">
              ¥{createdPayPrice.toFixed(2)}
            </p>
            <p className="text-sm text-muted-foreground">已标记为线下支付</p>
          </div>

          <div className="w-full max-w-xs rounded-lg border bg-muted/30 p-4">
            {hasPaymentQrcode ? (
              <div className="flex flex-col items-center gap-3">
                <div className="flex items-center gap-2 text-sm font-medium">
                  <QrCode className="h-4 w-4" />
                  <span>请客户扫码线下支付</span>
                </div>
                <img
                  src={paymentQrcode}
                  alt={`${paymentDepartmentName || '部门'}收款码`}
                  className="h-44 w-44 rounded-md border bg-white object-contain p-2"
                />
                {paymentDepartmentName && (
                  <p className="text-xs text-muted-foreground">
                    收款部门: {paymentDepartmentName}
                  </p>
                )}
              </div>
            ) : (
              <div className="flex items-start gap-2 text-sm text-muted-foreground">
                <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
                <span>{fallbackText}</span>
              </div>
            )}
          </div>

          <Button onClick={reset} className="w-full max-w-xs">
            继续创建订单
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
